import { render } from "./SettingsMap.vue?vue&type=template&id=3dfa7234"
import script from "./SettingsMap.vue?vue&type=script&lang=js"
export * from "./SettingsMap.vue?vue&type=script&lang=js"

import "./SettingsMap.vue?vue&type=style&index=0&id=3dfa7234&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__